import { useState, useEffect } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@easyflow/ui-master/components/ui/alert-dialog';
import { LogOut } from 'lucide-react';

interface ForceLogoutDialogProps {
  onConfirm: () => void;
}

export default function ForceLogoutDialog({ onConfirm }: ForceLogoutDialogProps) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleForceLogout = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setMessage(detail?.message || 'La tua sessione è stata chiusa perché è stato effettuato l\'accesso da un altro dispositivo.');
      setOpen(true);
    };

    window.addEventListener('session:force-logout-ui', handleForceLogout);
    return () => window.removeEventListener('session:force-logout-ui', handleForceLogout);
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <LogOut className="h-5 w-5 text-red-600" />
            </div>
            <AlertDialogTitle className="text-lg">Sessione terminata</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-muted-foreground">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            Torna al login
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
